@if (missingCreditScoreReason() === 0 || ficoScore) {
  <span>{{ ficoScore }}</span>
}
@if (missingCreditScoreReason() === 1 && !ficoScore) {
  <span class="grey" pTooltip="Missing" tooltipPosition="right">MISS</span>
}
@if (missingCreditScoreReason() === 2 && !ficoScore) {
  <span class="grey" pTooltip="Freeze" tooltipPosition="right">FRZ</span>
}
@if (missingCreditScoreReason() === 3 && !ficoScore) {
  <span class="grey" pTooltip="Not Requested" tooltipPosition="right">NR</span>
}
